import { Head, router } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { communitiesPath, familyPath, individualPath, rootPath } from "@travily/routes";
import type AccountsNew from "@travily/types/pages/AccountsNew";
import type { AccountType } from "@/components/AccountTypeCard/AccountTypeCard";
import { SetupFrame } from "@/layouts/setup-frame";
import { NewView } from "./new.view";

const TYPE_PATHS: Record<AccountType, () => string> = {
  family: familyPath,
  individual: individualPath,
  community: communitiesPath,
};

const AccountNewPage = ({ disabled_account_types }: AccountsNew) => {
  const handleSelectType = (type: AccountType) => {
    router.post(TYPE_PATHS[type]());
  };

  const handleSkip = () => {
    router.visit(rootPath());
  };

  return (
    <>
      <Head title={t("web.accounts.new.show.meta_title")}>
        <meta name="description" content={t("web.accounts.new.show.meta_description")} />
      </Head>
      <SetupFrame>
        <NewView onSelectType={handleSelectType} onSkip={handleSkip} disabledTypes={disabled_account_types} />
      </SetupFrame>
    </>
  );
};

export default AccountNewPage;
